<template>
  <div>
    <Modal title="请选择投保档次" width="600" v-model="visible" :mask-closable="false" :footer-hide="true" class="my-modal top">
      <div class="table-box">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :data="gradeList" style="margin-top: 20px">
          <template slot-scope="{ row }" slot="name">
            <span class="table-btn" @click="jump(row)">{{ row.grade }}</span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <Button @click="operateFn(row)" type="primary" v-if="operate == 'copyLink'">复制链接</Button>
            <Button @click="operateFn(row)" type="primary" v-if="operate == 'jump'">在线录单</Button>
          </template>
        </Table>
      </div>
    </Modal>

    <!-- ok保团险签约 -->
    <sign-popup ref="signPopup"></sign-popup>
  </div>
</template>

<script>
import vueQr from 'vue-qr';
import signPopup from './signPopup';
export default {
  props: [],
  components: {
    signPopup,
    vueQr
  },
  data() {
    return {
      visible: false,
      tableLoading: false,
      operate: '',
      userInfo: {},
      url: '',
      gradeList: [],
      tableItem: {},
      columns: [
        {
          title: '档次',
          slot: 'name',
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center'
        }
      ]
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  methods: {
    // 打开弹窗
    open(data, operate) {
      if (data.isSalePermission != 1) {
        //团险权限
        this.$notice.error('暂无该产品销售权限，请联系您的销售支持');
        return;
      } else if (this.userInfo.merchantNo == '260580000000800' && (!this.userInfo.isSign || !this.userInfo.isTrain)) {
        // ok保团险 需签约
        this.$refs.signPopup.open({
          type: !this.userInfo.isSign ? 1 : 2
        });
        return;
      }
      this.operate = operate;
      this.tableItem = data;
      if (this.operate == 'jump') {
        this.jump({ type: 1 });
      } else {
        this.visible = true;
        this.getGradeList();
      }
    },
    async jump(data) {
      this.tableLoading = true;
      let url = await this.getLink(data);
      this.tableLoading = false;
      window.open(url);
    },
    async operateFn(data) {
      this.tableLoading = true;
      let url = await this.getLink(data);
      url = await this.transformLongUrl(url);
      if (this.operate == 'copyLink') {
        this.$units.copyUrl(url);
      } else if (this.operate == 'jump') {
        window.open(url);
      }
      this.tableLoading = false;
    },
    getLink(data) {
      return this.$http({
        type: 'GET',
        url: '/buz/productBase/startPolicy',
        query: {
          productCode: this.tableItem.productCode,
          userId: this.userInfo.userid,
          grade: data.grade || '',
          type: data.type || 2,
          broker: this.operate == 'jump'
        }
      }).then(res => {
        return res.data;
      });
    },
    transformLongUrl(url) {
      return this.$http({
        url: '/buz/orderImport/transformLongUrl',
        type: 'PUT',
        data: {
          url: url
        }
      }).then(res => {
        return res.data;
      });
    },
    getGradeList() {
      this.$http({
        type: 'GET',
        url: '/buz/productBase/productGrades',
        query: {
          productCode: this.tableItem.productCode,
          userId: this.userInfo.userid
        }
      }).then(res => {
        this.gradeList = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
